import React, { useEffect } from "react";
import img1 from "../../assets/imgby_artist1.png";
import img2 from "../../assets/imgby_artist2.png";
import bellIcon from "../../assets/bell_icon.svg";
import { NotificationCard } from "../../components/notifications/NotificationsCard";
import { Header } from "../../components/header/Header";
import { createSelector } from "@reduxjs/toolkit";
import { useDispatch, useSelector } from "react-redux";
import { getNotificationThunk } from "../../slices/notifications/thunk";
import { getAuthUser, getFileUrl } from "../../utils/GetAuthUser";
export const Notifications = () => {

    const authUser=getAuthUser();
    const fileUrl=getFileUrl();
      const dispatch = useDispatch();
      const selectNotificationState = (state) => state.notifications;
      const contestSelector = createSelector(selectNotificationState, (notification) => ({
        isLoading: notification.isLoading,
        notificationsList: notification.notificationsList,

      }));

     const { notificationsList, isLoading } =useSelector(contestSelector);

     useEffect(() => {
         dispatch(getNotificationThunk({receiver_id:authUser.user.id}));
       }, [dispatch]);

    return (
        <>
        <header className="fixed top-0 left-0 md:left-[205px] md:w-[calc(100%-205px)] z-40 bg-white w-full h-14 md:h-[84px] flex items-center justify-center px-4 sm:px-[51px] border-b border-border_color ">
          {/* Header */}
          <Header  title={"Notification"} showBack={true}/>
        </header>
        <div className="w-full min-h-screen mx-auto bg-[#F7F7F7]">
            <div className="w-full max-w-[1164px] mx-auto ">
                <div className="flex flex-col gap-4">
                    {isLoading ? (
                        <div className="w-full bg-white p-6 rounded-2xl shadow-sm mt-5">
                            <span className="text-gray-600 font-medium">Loading notifications...</span>
                        </div>
                    ) : notificationsList && notificationsList.length > 0 ? (
                        notificationsList.map((item, index) => (
                            <NotificationCard 
                                key={index} 
                                title={item.title}
                                description={item.content}
                                mediaImages={item.contestMedia || []}
                                fileUrl={fileUrl}
                                primaryBtnText={"See Details"}
                                url={item.url}
                            />
                        ))
                    ) : (
                        <div className="w-full bg-white p-6 rounded-2xl shadow-sm mt-5 flex items-center gap-3">
                            <img src={bellIcon} alt="No notifications" className="w-8 h-8" />
                            <span className="text-gray-600 font-medium">No notifications yet.</span>
                        </div>
                    )}
                </div>
            </div>
        </div>
        </>
    )
}